export default __webpack_public_path__ + "static/compareItemImg2-17dd9c20b4b18b675bce781e97ecd13c.png";